import { useTranslation } from "react-i18next";

const ItemPackageInfos = ({ itemPackage }) => {
  const { t } = useTranslation();

  return (
    <>
      {itemPackage.packageLength && (
        <p>
          {t("itemPackages.packageLength", {
            length: itemPackage.packageLength,
          })}
        </p>
      )}
      {itemPackage.packageWidth && (
        <p>
          {t("itemPackages.packageWidth", { length: itemPackage.packageWidth })}
        </p>
      )}
      {itemPackage.packageHeight && (
        <p>
          {t("itemPackages.packageHeight", {
            length: itemPackage.packageHeight,
          })}
        </p>
      )}
      {itemPackage.packageWeight && (
        <p>
          {t("itemPackages.packageWeight", {
            length: itemPackage.packageWeight,
          })}
        </p>
      )}
    </>
  );
};

export default ItemPackageInfos;
